// The two small form helpers every Settings card uses. Split out of
// SettingsPage.tsx (2026-10-08) when the Pick-up range card became its own file.

import { Input } from "@bednbody/ui/components/input";
import { cn } from "@bednbody/ui/lib/utils";
import type { ReactNode } from "react";

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="flex min-w-0 flex-col items-start gap-2">
      <span className="text-sm font-medium text-foreground">{label}</span>
      {children}
    </label>
  );
}

export function NumberInput({
  value,
  onChange,
  step,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  step?: string;
  className?: string;
}) {
  return (
    <Input
      type="number"
      inputMode="decimal"
      min="0"
      step={step ?? "1"}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={cn("w-40 max-w-full tabular-nums", className)}
    />
  );
}
